'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const StyleOptions=[
'success',
'warning',
'info',
'alert',
'secondary',
'error'];let


NotificationService=class NotificationService extends BaseService{
constructor($rootScope){
super();
this._$rootScope=$rootScope;
this._$rootScope.alerts=[];
this._$rootScope.closeAlert=this._closeAlert.bind(this);
}

_closeAlert(index){
this._$rootScope.alerts.splice(index,1);
}

displayNotification(message,alertType='info'){
if(!_(StyleOptions).includes(alertType)){
throw new Error(`Alert type "${alertType}" is not a valid option.`);
}

if(alertType==='error'){
alertType='alert';
}

this._$rootScope.alerts.push({message:message,type:alertType});
}};


module.exports=NotificationService;
//# sourceMappingURL=notificationService.js.map
